import { Grid } from "@mui/material";
import React from "react";
import Title from "../components/Title";
import LastUpdate from "../components/LastUpdate";
import Report from "../components/Report";
import "./Home.css";
import { CurrentConditions } from "../api/ApiResponses";

interface HomeDesktopProps {
  currentConditions: CurrentConditions;
}

const HomeDesktop: React.FC<HomeDesktopProps> = ({ currentConditions }) => {
  return (
    <>
      {/* Title (Header) */}
      <Grid
        item
        container
        xs={12}
        height="38vh"
        textAlign="start"
        alignContent="center"
      >
        <Grid item xs={1} />
        <Grid item xs={11}>
          <Title />
        </Grid>
      </Grid>
      {/* Report (Body) */}
      <Grid container item height="58vh">
        {/* Spacing top */}
        <Grid item xs={12} height="0vh" />
        {/* Content */}
        <Grid item container height="58vh">
          <Grid item xs={1} />
          <Grid container item xs={10} alignItems={"center"}>
            <Report currentConditions={currentConditions} />
          </Grid>
          <Grid item xs={1} />
        </Grid>

        {/* Spacing bottom */}
        <Grid item xs={12} height="0vh" />
      </Grid>
      {/* Last Update (Footer) */}
      <Grid item xs={12} height="2vh">
        <LastUpdate timestamp={currentConditions.timestamp} />
      </Grid>
    </>
  );
};

export default HomeDesktop;
